// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"853cc349","225":"853cc349","276":"853cc349","368":"a9c4934f","484":"853cc349","574":"853cc349","772":"a9c4934f"}[chunkId] + ".chunk.css";
};